import { render, staticRenderFns } from "./material-accessories.vue?vue&type=template&id=73f2a092&scoped=true&"
import script from "./material-accessories.vue?vue&type=script&lang=js&"
export * from "./material-accessories.vue?vue&type=script&lang=js&"
import style0 from "./material-accessories.vue?vue&type=style&index=0&id=73f2a092&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f2a092",
  null
  
)

export default component.exports